import React from 'react';

import { ApButtonSecondary, ApButtonDanger } from '@alixpartners/ui-components';
import { StyledModal } from './DeleteMenu.styles';

export const DeleteDialog = ({ onClose, onDelete, title, text }) => {
	return (
		<StyledModal
			header={title}
			footer={() => (
				<React.Fragment>
					<ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>

					{onDelete && (
						<ApButtonDanger onClick={onDelete}>Delete</ApButtonDanger>
					)}
				</React.Fragment>
			)}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			{text}
		</StyledModal>
	);
};
